/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllEmployeesResponse } from '../../models/get-all-employees-response';

export interface GetAll_1$Params {
}

export function getAll_1(http: HttpClient, rootUrl: string, params?: GetAll_1$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllEmployeesResponse>> {
  const rb = new RequestBuilder(rootUrl, getAll_1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllEmployeesResponse>;
    })
  );
}

getAll_1.PATH = '/v1/configuration/integration/employees';
